<template>
  <v-col class="pa-0">
    <div v-if="!creatingUser" class="pa-6">
      <v-row>
        <v-col cols="12" md="3">
          <v-row class="ma-0" justify="center" justify-md="start">
            <v-text-field
              class="input"
              label="Search..."
              prepend-inner-icon="mdi-magnify"
              rounded
              v-model="search"
              style="max-width: 300px"
            ></v-text-field>
          </v-row>
        </v-col>
        <v-col cols="12" md="3">
          <v-row class="ma-0" justify="center" justify-md="start">
            <v-select
              style="max-width: 300px"
              class="input"
              label="Selected User Type"
              rounded
              v-model="userType"
              :items="userTypes"
              @change="
                updateSelectedType();
                getUpdates();
              "
            ></v-select>
          </v-row>
        </v-col>
        <v-col cols="12" md="6">
          <v-row justify="center" justify-md="end">
            <VueJsonToCsv
              :json-data="exportData"
              :csv-title="'Users'"
              class="export-btn my-6 mx-8"
            >
            </VueJsonToCsv>
          </v-row>
        </v-col>
        <!-- <v-col cols="12" md="3" class="pa-6">
            <v-row justify="center" justify-md="end" class="ma-0">
              <v-btn
                v-if="
                  storeUser.userType == 'Admin' &&
                  storeUser.adminType == 'Super Admin'
                "
                @click="
                  selectedUser = null;
                  creatingUser = true;
                "
                color="#e022d1"
                dark
                rounded
                width="240px"
                class="pink-btn"
              >
                Add New User
              </v-btn>
            </v-row>
          </v-col> -->
      </v-row>
      <v-row justify="center">
        <v-data-table
          no-data-text="No updates requested yet"
          style="width: 100%"
          :headers="headers"
          :items="filteredUpdates"
          :items-per-page="10"
          class="elevation-1 ml-4 mr-8"
        >
          <template v-slot:item.action="{ item }">
            <td>
              <v-icon
                color="#4390c0"
                @click="
                  selectedUser = item;
                  creatingUser = true;
                "
                >mdi-eye</v-icon
              >
            </td>
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip
              class="capatilize"
              :color="statusColor(item.status || 'pending')"
              dark
            >
              {{ item.status || "pending" }}
            </v-chip>
          </template>
        </v-data-table>
      </v-row>
    </div>
    <div v-if="creatingUser" class="pa-4">
      <HandleUser
        :companies="companies"
        :doctors="doctors"
        :userType="userType"
        :user="selectedUser"
        @userCreated="handleProfileUpdate()"
        @update="getUsers()"
      />
    </div>
    <v-row justify="center">
      <v-overlay :value="loading">
        <v-progress-circular
          :size="100"
          color="#4390c0"
          indeterminate
        ></v-progress-circular>
      </v-overlay>
    </v-row>
  </v-col>
</template>

<script>
import HandleUser from "../components/HandleUser.vue";

import VueJsonToCsv from "vue-json-to-csv";

import { auth } from "../../firebaseConfig.js";
import {
  signInWithEmailAndPassword,
  setPersistence,
  browserLocalPersistence,
  onAuthStateChanged,
} from "firebase/auth";
import {
  collection,
  getDocs,
  where,
  getFirestore,
  query,
  getDoc,
  doc,
  onSnapshot,
  addDoc,
} from "firebase/firestore";
import { firebaseApp } from "../../firebaseConfig";
const db = getFirestore(firebaseApp);

export default {
  data() {
    return {
      headers: [
        {
          text: "First Name",
          value: "name",
        },
        { text: "Surname", value: "surname" },
        { text: "ID No.", value: "idNumber" },
        { text: "Email Address", value: "email" },
        { text: "Cell Number", value: "CellNo" },
        { text: "Status", value: "status" },
        { text: "Action", value: "action" },
      ],
      creatingUser: false,
      userType: "Doctor",
      // userTypes: [],
      users: [],
      search: "",
      selectedUser: null,
      loading: false,
      companies: [],
      doctors: [],
      userTypes: ["Doctor", "Company"],
      unsubscribeUpdates: null,
      unsubscribeDoctors: null,
    };
  },
  components: {
    HandleUser,
    VueJsonToCsv,
  },
  async mounted() {
    if (localStorage.getItem("lastViewedUserType")) {
      this.userType = localStorage.getItem("lastViewedUserType");
    }

    let res = await this.getCompanies();
    let res2 = await this.getDoctors();
    let res3 = await this.getUpdates();

    if (localStorage.getItem("ViewedUser")) {
      let selectedUser = JSON.parse(localStorage.getItem("ViewedUser"));
      this.userType = selectedUser.userType;
      let newUser = this.users.find((user) => user.id == selectedUser.id);

      if (newUser) {
        this.selectedUser = newUser;
        this.creatingUser = true;
      }
    }
  },
  methods: {
    updateSelectedType() {
      localStorage.setItem("lastViewedUserType", this.userType);
    },
    handleProfileUpdate() {
      this.creatingUser = false;
    },
    updateSelectedType() {
      localStorage.setItem("lastViewedUserType", this.userType);
    },
    statusColor(status) {
      switch (status) {
        case "denied":
          return "#DC143C";
        case "pending":
          return "#4390c0";
        case "approved":
          return "green";
        case "on hold":
          return "grey";
        default:
          return "grey";
      }
    },
    getUpdates() {
      try {
        let q;

        if (this.userType === "Doctor") {
          q = query(collection(db, "doctorProfileUpdates"));
        } else if (this.userType === "Company") {
          q = query(collection(db, "companyProfileUpdates"));
        } else {
          return; // No updates for other user types
        }

        this.loading = true;

        // Subscribe to real-time updates
        this.unsubscribeUpdates = onSnapshot(q, (querySnapshot) => {
          this.users = [];

          querySnapshot.forEach((doc) => {
            let tempUser = doc.data();
            tempUser.id = doc.id;

            this.users.push(tempUser);
          });

          this.loading = false;
        });

        this.setHeaders();
      } catch (error) {
        this.loading = false;
        console.log("error: ", error);
      }
    },
    async getCompanies() {
      try {
        let q = query(collection(db, "businesses"));

        this.loading = true;
        const querySnapshot = await getDocs(q);
        this.loading = false;

        this.companies = [];

        querySnapshot.docs.forEach((doc) => {
          let tempCompany = doc.data();
          tempCompany.id = doc.id;

          this.companies.push(tempCompany);
        });
      } catch (error) {
        this.loading = false;
        console.log("error: ", error);
      }
    },
    getDoctors() {
      try {
        this.loading = true;
        const q = query(collection(db, "doctors"));

        // Subscribe to real-time updates
        this.unsubscribeDoctors = onSnapshot(q, (querySnapshot) => {
          this.doctors = [];

          querySnapshot.forEach((doctor) => {
            let tempDoctor = doctor.data();
            tempDoctor.id = doctor.id;

            this.doctors.push(tempDoctor);
          });

          this.loading = false;
        });
      } catch (error) {
        console.log("Error: ", error);
        this.loading = false;
        this.promptMessage = "An error occurred while fetching the doctors!";
        this.promptType = "error";
        this.promptDialog = true;
      }
    },
    setHeaders() {
      if (this.userType == "Company") {
        this.headers = [
          {
            text: "Company Name",
            value: "companyName",
          },
          { text: "Practice Number", value: "practiceNumber" },
          { text: "Email Address", value: "email" },
          { text: "Cell Number", value: "CellNo" },
          { text: "Address", value: "address.placeName" },
          { text: "Status", value: "status" },
          { text: "Action", value: "action" },
        ];
      } else if (this.userType == "Doctor") {
        this.headers = [
          {
            text: "First Name",
            value: "name",
          },
          { text: "Surname", value: "surname" },
          { text: "ID No.", value: "idNumber" },
          { text: "Email Address", value: "email" },
          { text: "Cell Number", value: "CellNo" },
          { text: "Status", value: "status" },
          { text: "Action", value: "action" },
        ];
      } else {
        this.headers = [
          {
            text: "First Name",
            value: "name",
          },
          { text: "Surname", value: "surname" },
          { text: "ID No.", value: "idNumber" },
          { text: "Email Address", value: "email" },
          { text: "Cell Number", value: "CellNo" },
          { text: "Admin Type", value: "adminType" },
          { text: "Action", value: "action" },
        ];
      }
    },
  },
  computed: {
    filteredUpdates() {
      return this.users.filter((item) => {
        const matchesStatus =
          !this.selectedStatus || item.status === this.selectedStatus;

        const matchesSearch = Object.values(item).some((value) => {
          if (value !== null && value !== undefined) {
            return value
              .toString()
              .toLowerCase()
              .includes(this.search.toLowerCase());
          }
          return false;
        });

        if (this.userType == "Admin") {
          return matchesSearch;
        } else if (this.storeUser.userType == "Admin") {
          return matchesStatus && matchesSearch;
        } else {
          return matchesSearch;
        }
      });
    },
    storeUser() {
      return this.$store.state.user;
    },
    exportData() {
      let objectList = [];
      let tempObject = {};

      if (this.filteredUpdates) {
        this.filteredUpdates.forEach((event) => {
          tempObject = {};

          tempObject.Name = event.name;
          tempObject.Surname = event.surname;
          tempObject.Profession = event.profession;
          tempObject.ClientPreference = event.clientPreference;
          tempObject.IDNumber = event.idNumber;
          tempObject.Email = event.email;
          tempObject.PhoneNumber = event.CellNo;
          tempObject.Address = event.address;

          objectList.push(tempObject);
        });

        return objectList;
      } else {
        return [{}];
      }
    },
  },
  beforeUnmount() {
    if (this.unsubscribeUpdates) {
      this.unsubscribeUpdates();
    }

    if (this.unsubscribeDoctors) {
      this.unsubscribeDoctors();
    }
  },
};
</script>

<style scoped></style>
